var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "modal fade modal__custom modal__toast",
        attrs: {
          id: "AlertModal" + _vm.modalId,
          tabindex: "-1",
          role: "dialog",
          "aria-labelledby": "AlertModalTitle",
          "aria-hidden": "true",
        },
      },
      [
        _c(
          "div",
          {
            staticClass: "modal-dialog modal-dialog-centered",
            attrs: { role: "document" },
          },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c(
                  "h5",
                  {
                    staticClass: "modal-title h_text",
                    class: _vm.getClass,
                    attrs: { id: "AlertModaTitle" },
                  },
                  [_vm._v(_vm._s(_vm.title))]
                ),
                _vm._v(" "),
                _c("button", {
                  staticClass: "close",
                  attrs: {
                    type: "button",
                    "data-bs-dismiss": "modal",
                    "aria-label": "Close",
                    id: "AlertModalBtnClose",
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "modal-body color__gray_1" },
                [
                  _c("p", [_vm._v(_vm._s(_vm.message))]),
                  _vm._v(" "),
                  _vm.promos.length
                    ? [
                        _c(
                          "table",
                          { staticClass: "table table__order_payment" },
                          [
                            _c(
                              "tbody",
                              _vm._l(_vm.promos, function (promo, key) {
                                return _c(
                                  "tr",
                                  {
                                    staticClass:
                                      "d-flex justify-content-between",
                                  },
                                  [
                                    _c(
                                      "td",
                                      { staticClass: "d-flex flex-column" },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.get_translation_constant(
                                                "text_order_number"
                                              )
                                            ) +
                                              "\n                                        " +
                                              _vm._s(promo.parcel.id) +
                                              "\n                                    "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.get_translation_constant(
                                                "text_promo_code"
                                              )
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.get_translation_constant(
                                                "text_total"
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "d-flex flex-column" },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(promo.old_price) + " $"
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(_vm._s(promo.discount) + " $"),
                                        ]),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(promo.parcel.total_price) +
                                              " $"
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                )
                              }),
                              0
                            ),
                          ]
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass:
          "btn btn__large btn__blue_border no_width opacity-0 d-none",
        attrs: {
          id: "AlertModalBtn" + _vm.modalId,
          href: "javascript:void(0)",
          "data-bs-toggle": "modal",
          "data-bs-target": "#AlertModal" + _vm.modalId,
        },
      },
      [_vm._v("+")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }